// /portal/health/:cycleId/preview — opened in its own window from the cycle
// page: the survey exactly as respondents see it, rendered from the cycle's
// pinned instrument version. Authed like every portal page; read-only.

import { useEffect, useState, type JSX } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { healthApi, HealthApiError, type InstrumentDefinition } from './api';
import { SurveyPreview } from './SurveyPreview';

export function CyclePreviewPage(): JSX.Element {
  const { cycleId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState<{ version: string; definition: InstrumentDefinition } | null>(
    null,
  );
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!cycleId) return;
    healthApi
      .cycleInstrument(cycleId)
      .then(setData)
      .catch((err: unknown) => {
        if (err instanceof HealthApiError && err.status === 401) {
          navigate(
            `/auth/login?returnTo=${encodeURIComponent(`/portal/health/${cycleId}/preview`)}`,
            { replace: true },
          );
          return;
        }
        setError('The survey preview could not be loaded. Please try again.');
      });
  }, [cycleId, navigate]);

  if (error) {
    return (
      <div className="card" style={{ maxWidth: 560, margin: '30px auto', textAlign: 'center' }}>
        <p style={{ fontSize: 14, color: 'var(--health-grey)', lineHeight: 1.7 }}>{error}</p>
      </div>
    );
  }
  if (!data) return <p style={{ color: 'var(--health-grey)' }}>Loading the survey...</p>;

  return (
    <div style={{ maxWidth: 760 }}>
      <SurveyPreview definition={data.definition} context={`instrument ${data.version}`} />
    </div>
  );
}
